import React, { useEffect, useState, useMemo } from "react";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import styles from './DefectiveProduct.module.css';
import {
    getNewProducts,
    getNewProductCategories,
    getDefectiveBatches,
    createDefectiveBatch,
    getDefectiveBatch,
    updateDefectiveBatchItems,
    deleteDefectiveBatch,
    getBulkProductWorks,
    getExtraWorks,
    getProductWorks
} from "../../Manager/Page/apiForNewProducts";
import { Modal, Button, Form } from "react-bootstrap";

function DefectiveProduct() {
    const [currentDate, setCurrentDate] = useState(new Date());
    const [isHiddenCalendar, setIsHiddenCalendar] = useState(true);
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [jwt] = useState(localStorage.getItem('jwtToken'));
    const [isLoad, setIsLoad] = useState(false);

    // Партии брака
    const [batches, setBatches] = useState([]);
    const [currentBatch, setCurrentBatch] = useState(null);
    const [batchItems, setBatchItems] = useState({});

    const [allWorks, setAllWorks] = useState([]);
    const [productWorksMap, setProductWorksMap] = useState({});

    const [showWorkModal, setShowWorkModal] = useState(false);
    const [currentProduct, setCurrentProduct] = useState(null);
    const [selectedWorkIds, setSelectedWorkIds] = useState([]);

    const [showCreateModal, setShowCreateModal] = useState(false);
    const [newBatchComment, setNewBatchComment] = useState("");

    // Загрузка продуктов и категорий
    useEffect(() => {
        Promise.all([
            getNewProducts(jwt),
            getNewProductCategories(jwt)
        ]).then(([prods, cats]) => {
            setProducts(prods);
            setCategories(cats);
        }).catch(err => console.error("Ошибка загрузки продуктов/категорий", err));
    }, [jwt]);

    // Загрузка всех работ
    useEffect(() => {
        getExtraWorks(jwt).then(data => {
            console.log("Загружены все работы:", data);
            setAllWorks(data);
        }).catch(err => console.error("Ошибка загрузки работ", err));
    }, [jwt]);

    useEffect(() => {
        if (!products.length) return;
        const loadProductWorks = async () => {
            try {
                const productIds = products.map(p => p.id);
                console.log("Запрос работ для продуктов:", productIds);
                const data = await getBulkProductWorks(productIds, jwt);
                console.log("Ответ getBulkProductWorks:", data);
                const map = {};
                Object.entries(data).forEach(([pid, works]) => {
                    map[pid] = works.map(w => w.extraWorkId);
                });
                setProductWorksMap(map);
            } catch (error) {
                console.error('Ошибка массовой загрузки работ, пробуем по одному', error);
                const map = {};
                await Promise.all(products.map(async (p) => {
                    try {
                        const works = await getProductWorks(p.id, jwt);
                        map[p.id] = works.map(w => w.WorkId);
                    } catch (e) {
                        console.warn(`Не удалось загрузить работы для продукта ${p.id}`, e);
                    }
                }));
                setProductWorksMap(map);
            }
        };
        loadProductWorks();
    }, [products, jwt]);

    // Загрузка партий при изменении даты
    useEffect(() => {
        loadBatches();
    }, [currentDate]);

    async function loadBatches() {
        setIsLoad(true);
        try {
            const list = await getDefectiveBatches(currentDate, jwt);
            console.log("Загружены партии:", list);
            setBatches(list);
            if (list.length) {
                // Если текущая партия не в списке, загружаем первую
                if (!currentBatch || !list.some(b => b.id === currentBatch.id)) {
                    await loadBatch(list[0].id);
                }
            } else {
                setCurrentBatch(null);
                setBatchItems({});
            }
        } catch (err) {
            console.error("Ошибка загрузки партий", err);
        } finally {
            setIsLoad(false);
        }
    }

    async function loadBatch(id) {
        setIsLoad(true);
        try {
            const batch = await getDefectiveBatch(id, jwt);
            console.log("Загружена партия:", batch);
            setCurrentBatch(batch);

            const items = {};
            products.forEach(p => {
                const existing = batch.items?.find(i => i.productId === p.id);
                items[p.id] = {
                    quantity: existing ? existing.quantity : 0,
                    workIds: existing ? existing.workIds : []
                };
            });
            console.log("batchItems после загрузки:", items);
            setBatchItems(items);
        } catch (err) {
            console.error("Ошибка загрузки партии", err);
        } finally {
            setIsLoad(false);
        }
    }

    function handleQuantityChange(productId, value) {
        setBatchItems(prev => ({
            ...prev,
            [productId]: {
                ...prev[productId],
                quantity: Number(value) || 0
            }
        }));
    }

    function openWorkModal(product) {
        setCurrentProduct(product);
        setSelectedWorkIds(batchItems[product.id]?.workIds || []);
        setShowWorkModal(true);
    }

    function handleSaveWorks() {
        setBatchItems(prev => ({
            ...prev,
            [currentProduct.id]: {
                ...prev[currentProduct.id],
                workIds: selectedWorkIds
            }
        }));
        setShowWorkModal(false);
    }

    const worksByDepartment = useMemo(() => {
        if (!currentProduct) return [];
        const allowedWorkIds = productWorksMap[currentProduct.id] || [];
        const allowedWorks = allWorks.filter(w => allowedWorkIds.includes(w.id));
        console.log(`Работы для продукта ${currentProduct.id}:`, allowedWorks);

        const groups = {};
        allowedWorks.forEach(work => {
            const deptName = work.ExtraWorkCategoryId || 'Без направления';
            if (!groups[deptName]) groups[deptName] = [];
            groups[deptName].push(work);
        });

        return Object.entries(groups).map(([deptName, works]) => ({ deptName, works }));
    }, [currentProduct, allWorks, productWorksMap]);

    async function handleSave() {
        if (!currentBatch) return;
        const items = Object.entries(batchItems)
            .filter(([_, val]) => val.quantity > 0)
            .map(([productId, val]) => ({
                productId: Number(productId),
                quantity: val.quantity,
                workIds: val.workIds
            }));
        console.log("Сохраняем элементы:", items);
        await updateDefectiveBatchItems(currentBatch.id, items, jwt);
        alert('Сохранено');
        await loadBatch(currentBatch.id);
    }

    async function handleCreateBatch() {
        await createDefectiveBatch(currentDate, newBatchComment, jwt);
        setShowCreateModal(false);
        loadBatches();
    }

    async function handleDeleteBatch() {
        if (!currentBatch || !window.confirm('Удалить партию?')) return;
        await deleteDefectiveBatch(currentBatch.id, jwt);
        loadBatches();
    }

    // Группировка продуктов по категориям
    const itemsByCategory = useMemo(() => {
        const result = [];
        const sortedCats = [...categories].sort((a, b) => a.priority - b.priority);
        sortedCats.forEach(cat => {
            const catProducts = products
                .filter(p => p.categoryId === cat.id)
                .sort((a, b) => a.priority - b.priority);
            if (catProducts.length) {
                const catItems = catProducts.map(p => ({
                    ...p,
                    quantity: batchItems[p.id]?.quantity || 0,
                    workIds: batchItems[p.id]?.workIds || [],
                }));
                result.push({ id: cat.id, name: cat.name, items: catItems });
            }
        });
        const noCatProducts = products
            .filter(p => !p.categoryId)
            .sort((a, b) => a.priority - b.priority);
        if (noCatProducts.length) {
            const noCatItems = noCatProducts.map(p => ({
                ...p,
                quantity: batchItems[p.id]?.quantity || 0,
                workIds: batchItems[p.id]?.workIds || [],
            }));
            result.push({ id: null, name: "Без категории", items: noCatItems });
        }
        return result;
    }, [products, categories, batchItems]);

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <button
                    className={styles.date}
                    onClick={() => setIsHiddenCalendar(!isHiddenCalendar)}
                >
                    {currentDate.toLocaleDateString()}
                </button>

                <div className={styles.orderSelector}>
                    <select
                        className={styles.orderSelect}
                        value={currentBatch?.id || ''}
                        onChange={e => loadBatch(Number(e.target.value))}
                    >
                        <option value="">-- Выберите партию --</option>
                        {batches.map(b => (
                            <option key={b.id} value={b.id}>
                                {b.comment || `Партия от ${new Date(b.batchDate).toLocaleDateString()}`}
                            </option>
                        ))}
                    </select>
                    <button
                        className={styles.createOrderButton}
                        onClick={() => setShowCreateModal(true)}
                    >
                        + Новая партия
                    </button>
                    {currentBatch && (
                        <>
                            <button className={styles.deleteOrderButton} onClick={handleDeleteBatch}>Удалить</button>
                            <button className={styles.saveButton} onClick={handleSave} disabled={isLoad}>Сохранить</button>
                        </>
                    )}
                </div>

                {currentBatch && (
                    <>
                        <div className={styles.productsSend} style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
                            {itemsByCategory.map(category => (
                                <div key={category.id} className={styles.categoryItem} style={{ width: '100%' }}>
                                    <div className={styles.titleCategory}>{category.name}</div>
                                    <div className={styles.categorySends}>
                                        {category.items.map(item => (
                                            <div key={item.id} className={styles.item}>
                                                <div className={styles.item_content}>
                                                    <span className={styles.item_text}>{item.name}</span>
                                                    <input
                                                        type="number"
                                                        className={styles.item_input}
                                                        value={item.quantity}
                                                        onChange={e => handleQuantityChange(item.id, e.target.value)}
                                                        min="0"
                                                    />
                                                </div>
                                                {(productWorksMap[item.id]?.length > 0) && (
                                                    <button
                                                        className={styles.workButton}
                                                        onClick={() => openWorkModal(item)}
                                                    >
                                                        {item.workIds.length > 0 ? `Выбрано работ: ${item.workIds.length}` : "Выбрать работы"}
                                                    </button>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <button
                            className={styles.save_button}
                            onClick={handleSave}
                            disabled={isLoad}
                        >
                            Сохранить
                        </button>
                    </>
                )}
            </div>

            <div
                className={styles.calendarBody}
                hidden={isHiddenCalendar}
                onClick={() => setIsHiddenCalendar(true)}
            >
                <Calendar
                    locale="ru-RU"
                    onChange={date => { setCurrentDate(date); setIsHiddenCalendar(true); }}
                    value={currentDate}
                />
            </div>

            <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Новая партия брака</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Комментарий</Form.Label>
                        <Form.Control
                            type="text"
                            value={newBatchComment}
                            onChange={e => setNewBatchComment(e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
                        Отмена
                    </Button>
                    <Button variant="primary" onClick={handleCreateBatch}>
                        Создать
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showWorkModal} onHide={() => setShowWorkModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Выбор работ для продукта: {currentProduct?.name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {worksByDepartment.length === 0 ? (
                        <p>У этого продукта нет привязанных работ</p>
                    ) : (
                        worksByDepartment.map(group => (
                            <div key={group.deptName} style={{ marginBottom: '20px' }}>
                                <h5>{group.deptName}</h5>
                                {group.works.map(work => (
                                    <div key={work.id} style={{ marginLeft: '15px' }}>
                                        <label>
                                            <input
                                                type="checkbox"
                                                checked={selectedWorkIds.includes(work.id)}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setSelectedWorkIds(prev => [...prev, work.id]);
                                                    } else {
                                                        setSelectedWorkIds(prev => prev.filter(id => id !== work.id));
                                                    }
                                                }}
                                            />
                                            {work.name} {work.mainCoefficient ? `(коэф. ${work.mainCoefficient})` : ''}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        ))
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowWorkModal(false)}>
                        Отмена
                    </Button>
                    <Button variant="primary" onClick={handleSaveWorks}>
                        Сохранить выбор
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default DefectiveProduct;